import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone'
import TimelineIcon from '@material-ui/icons/Timeline'
import FavoriteIcon from '@material-ui/icons/Favorite'
import HotelIcon from '@material-ui/icons/Hotel'
import OpacityIcon from '@material-ui/icons/Opacity'
import WatchIcon from '@material-ui/icons/Watch'
import AppShell from './components/layout/AppShell'
import PageCard from './components/ui/PageCard'
import Fitbit from './dashboard/Fitbit'
import FitbitSleep from './dashboard/FitbitSleep'
import Airbox from './dashboard/Airbox'
import Garmin from './dashboard/Garmin'
import GarminSpO2 from './dashboard/GarminSpO2'
import GarminHeartRate from './dashboard/GarminHeartRate'
import GarminSDK from './dashboard/GarminSDK'
import Visualdash from './dashboard/Visualdash'

class Dashboard extends React.Component {
  state = {
    group: {},
    user: {},
  }

  async getUserData() {
    const id = this.props.match.params.id
    try {
      const result = await fetch(`/api/getUserData?id=${id}`, {
        mode: 'cors',
        method: 'GET',
      })
      const data = await result.json()
      this.setState({ user: data })
    } catch (err) {
      this.props.history.push('/groups')
    }
  }

  async getGroupData() {
    const uniqid = this.props.match.params.uniqid
    try {
      const result = await fetch(`/api/getGroupData?uniqid=${uniqid}`, {
        mode: 'cors',
        method: 'GET',
      })
      const data = await result.json()
      if (data.success) this.setState({ group: data.data })
      else this.props.history.push('/groups')
    } catch (err) {
      this.props.history.push('/groups')
    }
  }

  componentDidMount() {
    this.getGroupData()
    this.getUserData()
  }

  buildSecondaryNav() {
    const { match, location } = this.props
    const items = [
      { key: 'fitbit', label: 'Fitbit', path: 'fitbit', icon: <WatchIcon /> },
      { key: 'fitbit_sleep', label: 'Fitbit 睡眠', path: 'fitbit_sleep', icon: <HotelIcon /> },
      { key: 'garmin', label: 'Garmin', path: 'garmin', icon: <TimelineIcon /> },
      { key: 'garminspo2', label: 'Garmin SpO2', path: 'garminspo2', icon: <OpacityIcon /> },
      { key: 'garmin_hr', label: 'Garmin HeartRate', path: 'garmin_hr', icon: <FavoriteIcon /> },
      { key: 'garmin_sdk', label: 'Garmin SDK', path: 'garmin_sdk', icon: <PhoneIphoneIcon /> },
      { key: 'visualdash', label: 'Visualization', path: 'visualdash', icon: <TimelineIcon /> },
    ]
    return items.map((item) => ({
      ...item,
      to: `${match.url}/${item.path}`,
      active: location.pathname.includes(`/${item.path}`),
    }))
  }

  render() {
    const { match } = this.props
    const uniqid = match.params.uniqid
    const id = match.params.id
    const userName = `${this.state.user.lastname || ''}${this.state.user.firstname || ''}`

    return (
      <AppShell
        uniqid={uniqid}
        title={userName || '個案儀表板'}
        subtitle={`${this.state.group.name || ''} · 個人數據`}
        secondaryNav={this.buildSecondaryNav()}
      >
        <PageCard>
          <Route
            path={`${match.url}/fitbit`}
            render={() => (
              <Fitbit
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="fitbit"
                uniqid={uniqid}
                id={id}
              />
            )}
          />
          <Route
            path={`${match.url}/fitbit_sleep`}
            render={() => (
              <FitbitSleep
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="fitbit_sleep"
                uniqid={uniqid}
                id={id}
              />
            )}
          />
          <Route
            path={`${match.url}/garmin`}
            render={() => (
              <Garmin
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="garmin"
                uniqid={uniqid}
                id={id}
              />
            )}
          />
          <Route
            path={`${match.url}/garminspo2`}
            render={() => (
              <GarminSpO2
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="garminspo2"
                uniqid={uniqid}
                id={id}
              />
            )}
          />
          <Route
            path={`${match.url}/garmin_hr`}
            render={() => (
              <GarminHeartRate
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="garmin_hr"
                uniqid={uniqid}
                id={id}
              />
            )}
          />
          <Route
            path={`${match.url}/garmin_sdk`}
            render={() => (
              <GarminSDK
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="garmin_sdk"
                uniqid={uniqid}
                id={id}
              />
            )}
          />
          <Route
            path={`${match.url}/airbox`}
            render={() => (
              <Airbox
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="airbox"
                uniqid={uniqid}
                id={id}
              />
            )}
          />
          <Route
            path={`${match.url}/visualdash`}
            render={() => (
              <Visualdash
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="visualdash"
                uniqid={uniqid}
                id={id}
              />
            )}
          />
        </PageCard>
      </AppShell>
    )
  }
}

Dashboard.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default Dashboard
